import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { StatTile } from '@cartcloser/ui';
import { formatMicros, formatRate, getAnalytics } from '../lib/api.js';

export const Route = createFileRoute('/admin/$slug/')({
  component: DashboardHome,
});

function DashboardHome() {
  const { slug } = Route.useParams();
  const analytics = useQuery({
    queryKey: ['analytics', slug, '30d'],
    queryFn: () => getAnalytics(slug, '30d'),
  });

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Dashboard</h1>
          <p className="text-sm text-muted-foreground">Live conversion performance, last 30 days.</p>
        </div>
        <Link
          to="/admin/$slug/analytics"
          params={{ slug }}
          className="text-sm font-medium text-primary hover:underline"
        >
          View analytics →
        </Link>
      </div>

      {analytics.isLoading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : analytics.isError || !analytics.data ? (
        <p className="text-sm text-destructive">Couldn’t load analytics.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatTile label="Conversations" value={analytics.data.conversations} />
          <StatTile
            label="Engagement"
            value={formatRate(analytics.data.engagementRate)}
            sub="reached a recommendation"
          />
          <StatTile
            label="Click-through"
            value={formatRate(analytics.data.clickThroughRate)}
            sub={`${analytics.data.recsClicked} of ${analytics.data.recsShown} shown`}
          />
          <StatTile
            label="Avg cost / chat"
            value={formatMicros(analytics.data.avgCostMicros)}
          />
        </div>
      )}
    </div>
  );
}
